import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import EmbedLayout from './components/EmbedLayout';
import Home from './pages/Home';
import BoardDetail from './pages/BoardDetail';
import EmbedBoard from './pages/EmbedBoard';
import EmbedWiringGuide from './pages/EmbedWiringGuide';
import EditBoard from './pages/EditBoard';
import Admin from './pages/Admin';
import CompareBoards from './pages/CompareBoards';
import WiringGuides from './pages/WiringGuides';
import WiringGuide from './pages/WiringGuide';
import WiringSuggest from './pages/WiringSuggest';
import Guides from './pages/Guides';
import GuideArticle from './pages/GuideArticle';
import GuidePreview from './pages/GuidePreview';
import ProjectBuilder from './pages/ProjectBuilder';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';
import About from './pages/About';
import Contact from './pages/Contact';
import ICPinoutDetail from './pages/ICPinoutDetails';
import NotFound from './pages/NotFound';
import { routerBasename } from './utils/appPaths';
import './styles/App.css';

function MainRoutes() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hideHeader = (
    location.pathname.startsWith('/builder') &&
    (
      searchParams.get('mode') === 'lesson' ||
      location.pathname.startsWith('/builder/lessons/')
    ) &&
    searchParams.get('embed') === '1'
  );

  return (
    <div className="App">
      {!hideHeader && <Header />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/board/preview/:id" element={<BoardDetail />} />
          <Route path="/boards/preview/:id" element={<BoardDetail />} />
          <Route path="/board/:id" element={<BoardDetail />} />
          <Route path="/boards/:id" element={<BoardDetail />} />
          <Route path="/compare" element={<CompareBoards />} />
          <Route path="/builder" element={<ProjectBuilder />} />
          <Route path="/builder/lessons/:lessonId" element={<ProjectBuilder />} />
          <Route path="/project-builder" element={<Navigate to="/builder" replace />} />
          <Route path="/wiring-guides" element={<WiringGuides />} />
          <Route path="/wiring-guide/:slug" element={<WiringGuide />} />
          <Route path="/WiringSuggest" element={<WiringSuggest />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/preview/:id" element={<GuidePreview />} />
          <Route path="/guides/:slug" element={<GuideArticle />} />
          <Route path="/ic-pinouts/:slug" element={<ICPinoutDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/admin/boards/:id/edit" element={<EditBoard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router basename={routerBasename}>
        <Routes>
          {/* Embed routes without header */}
          <Route path="/embed/*" element={<EmbedLayout />}>
            <Route path="board/:id" element={<EmbedBoard />} />
            <Route path="wiring-guide/:slug" element={<EmbedWiringGuide />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          
          {/* Regular routes with header */}
          <Route path="/*" element={<MainRoutes />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
